import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/components/HelloWorld";
import Home from "@/components/Home";
import ApplyCard from "@/components/ApplyCard";
import QueryOrder from "@/components/QueryOrder";
import CardTheme from "@/components/CardTheme";
import Identity from "@/components/Identity";
import MailAddress from "@/components/MailAddress";
import SelectCardface from "@/components/SelectCardface";
import EditCardface from "@/components/EditCardface";
import UploadCardface from "@/components/UploadCardface";
import OrderPay from "@/components/OrderPay";
import OrderList from "@/components/OrderList";
import OrderDetails from "@/components/OrderDetails";
import OrderResult from "@/components/OrderResult";
import Invoice from "@/components/Invoice";

//徽商银行
import Home_hs from "@/components/huishangbank/Home_hs";
import ApplyCard_hs from "@/components/huishangbank/ApplyCard_hs";
import QueryOrder_hs from "@/components/huishangbank/QueryOrder_hs";
import SelectCardface_hs from "@/components/huishangbank/SelectCardface_hs";
import EditCardface_hs from "@/components/huishangbank/EditCardface_hs";
import UploadCardface_hs from "@/components/huishangbank/UploadCardface_hs";
import OrderDetails_hs from "@/components/huishangbank/OrderDetails_hs";
import OrderList_hs from "@/components/huishangbank/OrderList_hs";
import OrderResult_hs from "@/components/huishangbank/OrderResult_hs";
import OrderPay_hs from "@/components/huishangbank/OrderPay_hs";
import GetCodeForOpenId_hs from "@/components/huishangbank/GetCodeForOpenId_hs";

//齐鲁银行
import Home_ql from "@/components/qilubank/Home_ql";
import ApplyCard_ql from "@/components/qilubank/ApplyCard_ql";
import QueryOrder_ql from "@/components/qilubank/QueryOrder_ql";
import SelectCardface_ql from "@/components/qilubank/SelectCardface_ql";
import EditCardface_ql from "@/components/qilubank/EditCardface_ql";
import UploadCardface_ql from "@/components/qilubank/UploadCardface_ql";
import OrderDetails_ql from "@/components/qilubank/OrderDetails_ql";
import OrderList_ql from "@/components/qilubank/OrderList_ql";
import OrderResult_ql from "@/components/qilubank/OrderResult_ql";
import OrderPay_ql from "@/components/qilubank/OrderPay_ql";
import Mailaddress_ql from "@/components/qilubank/mailaddress_ql";
import Invoice_ql from "@/components/qilubank/Invoice_ql"; //开具发票页面
import Invoicesq_ql from "@/components/qilubank/Invoicesq_ql"; //申请开具发票页面
import BaseApplyAction_ql from "@/components/qilubank/BaseApplyAction_ql"; //齐鲁银行制卡入口
import BaseQueryAction_ql from "@/components/qilubank/BaseQueryAction_ql"; //齐鲁银行查询入口

//齐商银行
import Home_qs from "@/components/qishangbank/Home_qs";
import ApplyCard_qs from "@/components/qishangbank/ApplyCard_qs";
import QueryOrder_qs from "@/components/qishangbank/QueryOrder_qs";
import SelectCardface_qs from "@/components/qishangbank/SelectCardface_qs";
import EditCardface_qs from "@/components/qishangbank/EditCardface_qs";
import UploadCardface_qs from "@/components/qishangbank/UploadCardface_qs";
import OrderDetails_qs from "@/components/qishangbank/OrderDetails_qs";
import OrderList_qs from "@/components/qishangbank/OrderList_qs";
import OrderResult_qs from "@/components/qishangbank/OrderResult_qs";
import OrderPay_qs from "@/components/qishangbank/OrderPay_qs";
import Mailaddress_qs from "@/components/qishangbank/mailaddress_qs";
import Invoice_qs from "@/components/qishangbank/Invoice_qs"; //开具发票页面
import Invoicesq_qs from "@/components/qishangbank/Invoicesq_qs"; //申请开具发票页面
import BaseApplyAction_qs from "@/components/qishangbank/BaseApplyAction_qs"; //银行制卡入口
import BaseQueryAction_qs from "@/components/qishangbank/BaseQueryAction_qs"; //银行查询入口
import GetCodeForOpenId_qs from "@/components/qishangbank/GetCodeForOpenId_qs";

//入口
import BaseApplyAction from "@/components/base/BaseApplyAction";
import BaseQueryAction from "@/components/base/BaseQueryAction";

//四川中行
import SelectCardface_sczh from "@/components/sichuanzhonghang/SelectCardface_sczh";
import EditCardface_sczh from "@/components/sichuanzhonghang/EditCardface_sczh";
import UploadCardface_sczh from "@/components/sichuanzhonghang/UploadCardface_sczh";
import OrderPay_sczh from "@/components/sichuanzhonghang/OrderPay_sczh";
import OrderResult_sczh from "@/components/sichuanzhonghang/OrderResult_sczh";
import OrderList_sczh from "@/components/sichuanzhonghang/OrderList_sczh";
import OrderDetails_sczh from "@/components/sichuanzhonghang/OrderDetails_sczh";

//乌鲁木齐商行
import SelectCardface_wlmqsh from "@/components/wulumuqishbank/SelectCardface_wlmqsh";
import EditCardface_wlmqsh from "@/components/wulumuqishbank/EditCardface_wlmqsh";
import UploadCardface_wlmqsh from "@/components/wulumuqishbank/UploadCardface_wlmqsh";

//深圳农商行
import Home_shzhnsh from "@/components/shenzhennshbank/Home_shzhnsh.vue";
import SelectCardface_shzhnsh from "@/components/shenzhennshbank/SelectCardface_shzhnsh";
import UploadCardface_shzhnsh from "@/components/shenzhennshbank/UploadCardface_shzhnsh.vue";
import EditCardface_shzhnsh from "@/components/shenzhennshbank/EditCardface_shzhnsh.vue";
import OrderList_shzhnsh from "@/components/shenzhennshbank/OrderList_shzhnsh.vue";
import OrderDetails_shzhnsh from "@/components/shenzhennshbank/OrderDetails_shzhnsh.vue";

//四川天府银行
import EditCardface_schtnf from "@/components/sichuantianfubank/EditCardface_schtnf.vue";
import OrderDetails_schtnf from "@/components/sichuantianfubank/OrderDetails_schtnf";
import OrderList_schtnf from "@/components/sichuantianfubank/OrderList_schtnf.vue";
import QueryOrder_schtnf from "@/components/sichuantianfubank/QueryOrder_schtnf.vue";
import SelectCardface_schtnf from "@/components/sichuantianfubank/SelectCardface_schtnf.vue";
import UploadCardface_schtnf from "@/components/sichuantianfubank/UploadCardface_schtnf.vue";

//四川绵阳商行
import Home_schmysh from "@/components/sichuanmianyangbank/Home_schmysh.vue";
import SelectCardface_schmysh from "@/components/sichuanmianyangbank/SelectCardface_schmysh.vue";
import EditCardface_schmysh from "@/components/sichuanmianyangbank/EditCardface_schmysh.vue";
import UploadCardface_schmysh from "@/components/sichuanmianyangbank/UploadCardface_schmysh.vue";
import OrderResult_schmysh from "@/components/sichuanmianyangbank/OrderResult_schmysh.vue";
import OrderList_schmysh from "@/components/sichuanmianyangbank/OrderList_schmysh.vue";
import OrderDetails_schmysh from "@/components/sichuanmianyangbank/OrderDetails_schmysh.vue";

// 襄阳公交定制DIY卡
import Home_xy from "@/components/xiangyang/Home_xy.vue";
import ApplyCard_xy from "@/components/xiangyang/ApplyCard_xy";
import QueryOrder_xy from "@/components/xiangyang/QueryOrder_xy";
import SelectCardface_xy from "@/components/xiangyang/SelectCardface_xy";
import EditCardface_xy from "@/components/xiangyang/EditCardface_xy";
import UploadCardface_xy from "@/components/xiangyang/UploadCardface_xy";
import OrderDetails_xy from "@/components/xiangyang/OrderDetails_xy";
import OrderList_xy from "@/components/xiangyang/OrderList_xy";
import OrderResult_xy from "@/components/xiangyang/OrderResult_xy";
import OrderPay_xy from "@/components/xiangyang/OrderPay_xy";
import GetCodeForOpenId_xy from "@/components/xiangyang/GetCodeForOpenId_xy";

// 襄阳公交App定制DIY卡
import Home_app_xy from "@/components/xiangyangApp/Home_app_xy.vue";
import ApplyCard_app_xy from "@/components/xiangyangApp/ApplyCard_app_xy";
import QueryOrder_app_xy from "@/components/xiangyangApp/QueryOrder_app_xy";
import SelectCardface_app_xy from "@/components/xiangyangApp/SelectCardface_app_xy";
import EditCardface_app_xy from "@/components/xiangyangApp/EditCardface_app_xy";
import UploadCardface_app_xy from "@/components/xiangyangApp/UploadCardface_app_xy";
import OrderDetails_app_xy from "@/components/xiangyangApp/OrderDetails_app_xy";
import OrderList_app_xy from "@/components/xiangyangApp/OrderList_app_xy";
import OrderResult_app_xy from "@/components/xiangyangApp/OrderResult_app_xy";
import OrderPay_app_xy from "@/components/xiangyangApp/OrderPay_app_xy";
import GetCodeForOpenId_app_xy from "@/components/xiangyangApp/GetCodeForOpenId_app_xy";

// 泰州公交定制DIY卡
import Home_tai from "@/components/taizhouBus/Home_tai.vue";
import ApplyCard_tai from "@/components/taizhouBus/ApplyCard_tai.vue";
import SelectCardface_tai from "@/components/taizhouBus/SelectCardface_tai.vue";
import EditCardface_tai from "@/components/taizhouBus/EditCardface_tai.vue";
import UploadCardface_tai from "@/components/taizhouBus/UploadCardface_tai.vue";
import OrderPay_tai from "@/components/taizhouBus/OrderPay_tai.vue";
import GetCodeForOpenId_tai from "@/components/taizhouBus/GetCodeForOpenId_tai.vue";
import OrderResult_tai from "@/components/taizhouBus/OrderResult_tai.vue";
import OrderDetails_tai from "@/components/taizhouBus/OrderDetails_tai.vue";
import OrderList_tai from "@/components/taizhouBus/OrderList_tai.vue";
import QueryOrder_tai from "@/components/taizhouBus/QueryOrder_tai.vue";



// DIY_model 
// 公共页面
import HomePage from "@/components/DIYApplyCardSurface/HomePage";
import InformationFilling from "@/components/DIYApplyCardSurface/ApplicationCard/InformationFilling";
import OrderPay_demo from "@/components/DIYApplyCardSurface/ApplicationCard/OrderPay.vue";
import SelectBusinessProcess from "@/components/DIYApplyCardSurface/ApplicationCard/SelectBusinessProcess.vue";
import GetCodeForOpenId_demo from "@/components/DIYApplyCardSurface/ApplicationCard/GetCodeForOpenId.vue";
import OrderResult_demo from "@/components/DIYApplyCardSurface/ApplicationCard/OrderResult.vue";
// 自定义卡面
import SelectCardface_demo from "@/components/DIYApplyCardSurface/ApplicationCard/CustomLayout/SelectCardface_demo.vue";
import EditCardface_demo from "@/components/DIYApplyCardSurface/ApplicationCard/CustomLayout/EditCardface_demo.vue";
import UploadCardface_demo from "@/components/DIYApplyCardSurface/ApplicationCard/CustomLayout/UploadCardface_demo.vue";
import ThreeD from "@/components/DIYApplyCardSurface/ApplicationCard/CustomLayout/ThreeD.vue";
// AI申请页面
import AISelectCardface from "@/components/DIYApplyCardSurface/ApplicationCard/AIProcess/AISelectCardface.vue";
import AItext_to_image from "@/components/DIYApplyCardSurface/ApplicationCard/AIProcess/AItext_to_image.vue";
import AIimage_text_to_image from "@/components/DIYApplyCardSurface/ApplicationCard/AIProcess/AIimage_text_to_image.vue";
import AIimage_to_image from "@/components/DIYApplyCardSurface/ApplicationCard/AIProcess/AIimage_to_image.vue";
import AICollection from "@/components/DIYApplyCardSurface/ApplicationCard/AIProcess/AICollection.vue";
import AIEditCardface from "@/components/DIYApplyCardSurface/ApplicationCard/AIProcess/AIEditCardface.vue";
import AIUploadCardface from "@/components/DIYApplyCardSurface/ApplicationCard/AIProcess/AIUploadCardface.vue";
import AIThreeD from "@/components/DIYApplyCardSurface/ApplicationCard/AIProcess/AIThreeD.vue";
import AItest from "@/components/DIYApplyCardSurface/ApplicationCard/AIProcess/test.vue";
// 查询
import QueryOrder_demo from "@/components/DIYApplyCardSurface/CheckProgress/QueryOrder_demo";
import OrderList_demo from "@/components/DIYApplyCardSurface/CheckProgress/OrderList_demo";
import OrderDetails_demo from "@/components/DIYApplyCardSurface/CheckProgress/OrderDetails_demo";


// 郑州一卡通
import Home_zz from "@/components/zhengzhouonebank/Home_zz.vue";
import ApplyCard_zz from "@/components/zhengzhouonebank/ApplyCard_zz";
import QueryOrder_zz from "@/components/zhengzhouonebank/QueryOrder_zz";
import SelectCardface_zz from "@/components/zhengzhouonebank/SelectCardface_zz";
import EditCardface_zz from "@/components/zhengzhouonebank/EditCardface_zz";
import UploadCardface_zz from "@/components/zhengzhouonebank/UploadCardface_zz";
import OrderDetails_zz from "@/components/zhengzhouonebank/OrderDetails_zz";
import OrderList_zz from "@/components/zhengzhouonebank/OrderList_zz";
import OrderResult_zz from "@/components/zhengzhouonebank/OrderResult_zz";
import OrderPay_zz from "@/components/zhengzhouonebank/OrderPay_zz";
import GetCodeForOpenId_zz from "@/components/zhengzhouonebank/GetCodeForOpenId_zz";

// 湖南银行
import Agreement from "@/components/hunanbank/Agreement.vue";
import ApplyForCard from "@/components/hunanbank/ApplyForCard.vue";
import CardPreview from "@/components/hunanbank/CardPreview.vue";

// 迪拜及时制卡系统
import Home_Dubai from "@/components/DubaiCard/Home_Dubai.vue"
import ApplyCard_Dubai from "@/components/DubaiCard/ApplyCard_Dubai.vue"
import SelectCardface_Dubai from "@/components/DubaiCard/SelectCardface_Dubai.vue"
import EditCardface_Dubai from "@/components/DubaiCard/EditCardface_Dubai.vue"
import UploadCardface_Dubai from "@/components/DubaiCard/UploadCardface_Dubai.vue"
import OrderPay_Dubai from "@/components/DubaiCard/OrderPay_Dubai.vue"
import OrderResult_Dubai from "@/components/DubaiCard/OrderResult_Dubai.vue"
import Select_chongwu_Dubai from "@/components/DubaiCard/Select_chongwu_Dubai.vue"
import Select_fengjing_Dubai from "@/components/DubaiCard/Select_fengjing_Dubai.vue"
import Select_keji_Dubai from "@/components/DubaiCard/Select_keji_Dubai.vue"
import Select_zhiwu_Dubai from "@/components/DubaiCard/Select_zhiwu_Dubai.vue"
import select_card from "@/components/DubaiCard/select_card.vue"
import QueryOrder_Dubai from "@/components/DubaiCard/QueryOrder_Dubai.vue"
import OrderList_Dubai from "@/components/DubaiCard/OrderList_Dubai.vue"

// 青岛农商银行
import SelectCardface_qingdao from "@/components/qingdaobank/SelectCardface_qingdao.vue"
import EditCardface_qingdao from "@/components/qingdaobank/EditCardface_qingdao.vue"
import UploadCardface_qingdao from "@/components/qingdaobank/UploadCardface_qingdao.vue"
import GetCodeForOpenId_qingdao from "@/components/qingdaobank/GetCodeForOpenId_qingdao.vue"
import OrderPay_qingdao from "@/components/qingdaobank/OrderPay_qingdao.vue"

// 洪城通DIY卡
import Home_hongcheng from "@/components/hongcheng/Home_hongcheng.vue";
import ApplyCard_hongcheng from "@/components/hongcheng/ApplyCard_hongcheng";
import QueryOrder_hongcheng from "@/components/hongcheng/QueryOrder_hongcheng";
import SelectCardface_hongcheng from "@/components/hongcheng/SelectCardface_hongcheng";
import EditCardface_hongcheng from "@/components/hongcheng/EditCardface_hongcheng";
import UploadCardface_hongcheng from "@/components/hongcheng/UploadCardface_hongcheng";
import OrderDetails_hongcheng from "@/components/hongcheng/OrderDetails_hongcheng";
import OrderList_hongcheng from "@/components/hongcheng/OrderList_hongcheng";
import OrderResult_hongcheng from "@/components/hongcheng/OrderResult_hongcheng";
import OrderPay_hongcheng from "@/components/hongcheng/OrderPay_hongcheng";
import GetCodeForOpenId_hongcheng from "@/components/hongcheng/GetCodeForOpenId_hongcheng";
import AlipayH5_hongcheng from "@/components/hongcheng/AlipayH5_hongcheng";

// 泸州银行
import EditCardface_luzh from "@/components/luzhoubank/EditCardface_luzh.vue"
import SelectCardface_luzh from "@/components/luzhoubank/SelectCardface_luzh.vue"
import test_luzhou from "@/components/luzhoubank/test_luzhou"

import Test from "@/components/Test";


//  宁波公交
import test_ningbo from "@/components/ningboBus/test.vue";
import home_ningbo from "@/components/ningboBus/home_ningbo.vue";
// 固定卡面
// import fixedCardFace_ningbo from "@/components/ningboBus/FixedCardFace/fixedCardFace_ningbo.vue";
// AI页面
import informationFilling_ai_ningbo from "@/components/ningboBus/AIGC/InformationFilling_ningbo.vue";
import AISelectCardface_ningbo from "@/components/ningboBus/AIGC/AISelectCardface.vue";
import AICollection_ningbo from "@/components/ningboBus/AIGC/AICollection.vue";
import AIimage_text_to_image_ningbo from "@/components/ningboBus/AIGC/AIimage_text_to_image.vue";
import AIimage_to_image_ningbo from "@/components/ningboBus/AIGC/AIimage_to_image.vue";
import AItext_to_image_ningbo from "@/components/ningboBus/AIGC/AItext_to_image.vue";
import AIEditCardface_ningbo from "@/components/ningboBus/AIGC/AIEditCardface.vue";
import SelectReverseSide_ai_ningbo from "@/components/ningboBus/AIGC/SelectReverseSide_ningbo.vue";
import uploadCardface_ai_ningbo from "@/components/ningboBus/AIGC/uploadCardface_ningbo.vue";
// 抠图页面
import matting_ningbo from "@/components/ningboBus/Matting/Matting.vue";
import matting_ningbogirl from "@/components/ningboBus/Matting/matting_01.vue";
import matting_ningboboy from "@/components/ningboBus/Matting/matting_02.vue";
import matting_ningbolovers from "@/components/ningboBus/Matting/matting_03.vue";
import matting_ningbocute from "@/components/ningboBus/Matting/matting_04.vue";
import selectTopic_ningbo from "@/components/ningboBus/Matting/SelectTopic.vue";
import selectReverseSide_matting_ningbo from "@/components/ningboBus/Matting/SelectReverseSide_ningbo.vue";
import uploadCardface_matting_ningbo from "@/components/ningboBus/Matting/UploadCardface_ningbo.vue";
import informationFilling_matting_ningbo from "@/components/ningboBus/Matting/InformationFilling_ningbo.vue";
import orderPay_matting_ningbo from "@/components/ningboBus/Matting/OrderPay_ningbo.vue";
import getCodeForOpenId_matting_ningbo from "@/components/ningboBus/Matting/GetCodeForOpenId_ningbo.vue";
import orderResult_matting_ningbo from "@/components/ningboBus/Matting/OrderResult_ningbo.vue";
// 自选卡面
import selectCardface_customs_ningbo from "@/components/ningboBus/Customs/SelectCardface_ningbo.vue";
import editCardface_customs_ningbo from "@/components/ningboBus/Customs/EditCardface_ningbo.vue";
import selectReverseSide_customs_ningbo from "@/components/ningboBus/Customs/SelectReverseSide_ningbo.vue";
import uploadCardface_customs_ningbo from "@/components/ningboBus/Customs/UploadCardface_ningbo.vue";
import informationFilling_customs_ningbo from "@/components/ningboBus/Customs/InformationFilling_ningbo.vue";
import orderPay_customs_ningbo from "@/components/ningboBus/Customs/OrderPay_ningbo.vue";
import getCodeForOpenId_customs_ningbo from "@/components/ningboBus/Customs/GetCodeForOpenId_ningbo.vue";
import orderResult_customs_ningbo from "@/components/ningboBus/Customs/OrderResult_ningbo.vue";
// 查询
import orderDetails_ningbo from "@/components/ningboBus/CheckProgress/OrderDetails_ningbo.vue";
import orderList_ningbo from "@/components/ningboBus/CheckProgress/OrderList_ningbo.vue";
import queryOrder_ningbo from "@/components/ningboBus/CheckProgress/QueryOrder_ningbo.vue";
// 支付
import orderPay_ningbo from "@/components/ningboBus/OrderPay_ningbo.vue";
import getCodeForOpenId_ningbo from "@/components/ningboBus/GetCodeForOpenId_ningbo.vue";
import orderResult_ningbo from "@/components/ningboBus/OrderResult_ningbo.vue";
import invoicesq_ningbo from "@/components/ningboBus/Invoicesq_ningbo.vue";
// 支付app
import orderPay_app_ningbo from "@/components/ningboBus/OrderPay_app_ningbo.vue";
import getCodeForOpenId_app_ningbo from "@/components/ningboBus/GetCodeForOpenId_app_ningbo.vue";





Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/helloWorld",
      name: "HelloWorld",
      component: HelloWorld
    },
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        title: "DIY卡面"
      }
    },
    {
      path: "/applyCard",
      name: "ApplyCard",
      component: ApplyCard
    },
    {
      path: "/queryOrder",
      name: "QueryOrder",
      component: QueryOrder
    },
    {
      path: "/cardTheme",
      name: "CardTheme",
      component: CardTheme
    },
    {
      path: "/identity",
      name: "Identity",
      component: Identity
    },
    {
      path: "/mailAddress",
      name: "MailAddress",
      component: MailAddress
    },
    {
      path: "/selectCardface",
      name: "SelectCardface",
      component: SelectCardface
    },
    {
      path: "/editCardface",
      name: "EditCardface",
      component: EditCardface
    },
    {
      path: "/uploadCardface",
      name: "UploadCardface",
      component: UploadCardface
    },
    {
      path: "/orderPay",
      name: "OrderPay",
      component: OrderPay
    },
    {
      path: "/orderList",
      name: "OrderList",
      component: OrderList
    },
    {
      path: "/orderDetails",
      name: "OrderDetails",
      component: OrderDetails
    },
    {
      path: "/test",
      name: "Test",
      component: Test
    },
    {
      path: "/orderResult",
      name: "OrderResult",
      component: OrderResult
    },
    {
      path: "/invoice",
      name: "Invoice",
      component: Invoice
    },
    {
      path: "/hs/home_hs",
      name: "Home_hs",
      component: Home_hs,
      meta: {
        title: "徽商银行徽宝成长卡"
      }
    },
    {
      path: "/hs/applyCard_hs",
      name: "ApplyCard_hs",
      component: ApplyCard_hs,
      meta: {
        title: "信息核验",
        keepAlive: true
      }
    },
    {
      path: "/hs/queryOrder_hs",
      name: "QueryOrder_hs",
      component: QueryOrder_hs,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/hs/selectCardface_hs",
      name: "SelectCardface_hs",
      component: SelectCardface_hs,
      meta: {
        title: "版面定制服务",
        keepAlive: true
      }
    },
    {
      path: "/hs/editCardface_hs",
      name: "EditCardface_hs",
      component: EditCardface_hs,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/hs/uploadCardface_hs",
      name: "UploadCardface_hs",
      component: UploadCardface_hs,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/hs/orderList_hs",
      name: "OrderList_hs",
      component: OrderList_hs,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/hs/orderDetails_hs",
      name: "OrderDetails_hs",
      component: OrderDetails_hs,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/hs/orderResult_hs",
      name: "OrderResult_hs",
      component: OrderResult_hs,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/hs/orderPay_hs",
      name: "OrderPay_hs",
      component: OrderPay_hs,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/hs/getCodeForOpenId_hs",
      name: "GetCodeForOpenId_hs",
      component: GetCodeForOpenId_hs,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/base/baseApplyAction",
      name: "BaseApplyAction",
      component: BaseApplyAction,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/base/baseQueryAction",
      name: "BaseQueryAction",
      component: BaseQueryAction,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/sczh/selectCardface_sczh",
      name: "SelectCardface_sczh",
      component: SelectCardface_sczh,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/sczh/editCardface_sczh",
      name: "EditCardface_sczh",
      component: EditCardface_sczh,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/sczh/uploadCardface_sczh",
      name: "UploadCardface_sczh",
      component: UploadCardface_sczh,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/sczh/orderPay_sczh",
      name: "OrderPay_sczh",
      component: OrderPay_sczh,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/sczh/orderResult_sczh",
      name: "OrderResult_sczh",
      component: OrderResult_sczh,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/sczh/orderList_sczh",
      name: "OrderList_sczh",
      component: OrderList_sczh,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/sczh/orderDetails_sczh",
      name: "OrderDetails_sczh",
      component: OrderDetails_sczh,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/wlmqsh/selectCardface_wlmqsh",
      name: "SelectCardface_wlmqsh",
      component: SelectCardface_wlmqsh,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/wlmqsh/editCardface_wlmqsh",
      name: "EditCardface_wlmqsh",
      component: EditCardface_wlmqsh,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/wlmqsh/uploadCardface_wlmqsh",
      name: "UploadCardface_wlmqsh",
      component: UploadCardface_wlmqsh,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      //齐鲁银行
      path: "/ql/home_ql",
      name: "Home_ql",
      component: Home_ql,
      meta: {
        title: "齐鲁银行DIY"
      }
    },
    {
      path: "/ql/applyCard_ql",
      name: "ApplyCard_ql",
      component: ApplyCard_ql,
      meta: {
        title: "选择领卡网点",
        keepAlive: true
      }
    },
    {
      path: "/ql/queryOrder_ql",
      name: "QueryOrder_ql",
      component: QueryOrder_ql,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/ql/selectCardface_ql",
      name: "SelectCardface_ql",
      component: SelectCardface_ql,
      meta: {
        title: "卡面定制服务",
        keepAlive: true
      }
    },
    {
      path: "/ql/editCardface_ql",
      name: "EditCardface_ql",
      component: EditCardface_ql,
      meta: {
        title: "卡面定制服务"
      }
    },
    {
      path: "/ql/uploadCardface_ql",
      name: "UploadCardface_ql",
      component: UploadCardface_ql,
      meta: {
        title: "卡面定制服务"
      }
    },
    {
      path: "/ql/orderList_ql",
      name: "OrderList_ql",
      component: OrderList_ql,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/ql/orderDetails_ql",
      name: "OrderDetails_ql",
      component: OrderDetails_ql,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/ql/orderResult_ql",
      name: "OrderResult_ql",
      component: OrderResult_ql,
      meta: {
        title: "卡面定制服务"
      }
    },
    {
      path: "/ql/orderPay_ql",
      name: "OrderPay_ql",
      component: OrderPay_ql,
      meta: {
        title: "卡面定制服务"
      }
    },
    {
      path: "/ql/mailaddress_ql",
      name: "mailaddress_ql",
      component: Mailaddress_ql,
      meta: {
        title: "卡面定制服务"
      }
    },
    {
      path: "/base/BaseQueryAction_ql",
      name: "BaseQueryAction_ql",
      component: BaseQueryAction_ql,
      meta: {
        title: "齐鲁银行查询入口"
      }
    },
    {
      path: "/base/BaseApplyAction_ql",
      name: "BaseApplyAction_ql",
      component: BaseApplyAction_ql,
      meta: {
        title: "齐鲁银行制卡入口"
      }
    },
    {
      path: "/base/Invoice_ql",
      name: "Invoice_ql",
      component: Invoice_ql,
      meta: {
        title: "开具发票"
      }
    },
    {
      path: "/base/Invoicesq_ql",
      name: "Invoicesq_ql",
      component: Invoicesq_ql,
      meta: {
        title: "开具发票"
      }
    },
    //齐鲁银行
    {
      //齐商银行
      path: "/qs/home_qs",
      name: "Home_qs",
      component: Home_qs,
      meta: {
        title: "齐商银行儿童主题卡"
      }
    },
    {
      path: "/qs/applyCard_qs",
      name: "ApplyCard_qs",
      component: ApplyCard_qs,
      meta: {
        title: "邮寄地址",
        keepAlive: true
      }
    },
    {
      path: "/qs/queryOrder_qs",
      name: "QueryOrder_qs",
      component: QueryOrder_qs,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/qs/selectCardface_qs",
      name: "SelectCardface_qs",
      component: SelectCardface_qs,
      meta: {
        title: "卡面定制服务",
        keepAlive: true
      }
    },
    {
      path: "/qs/editCardface_qs",
      name: "EditCardface_qs",
      component: EditCardface_qs,
      meta: {
        title: "卡面定制服务"
      }
    },
    {
      path: "/qs/uploadCardface_qs",
      name: "UploadCardface_qs",
      component: UploadCardface_qs,
      meta: {
        title: "卡面定制服务"
      }
    },
    {
      path: "/qs/orderList_qs",
      name: "OrderList_qs",
      component: OrderList_qs,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/qs/orderDetails_qs",
      name: "OrderDetails_qs",
      component: OrderDetails_qs,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/qs/orderResult_qs",
      name: "OrderResult_qs",
      component: OrderResult_qs,
      meta: {
        title: "卡面定制服务"
      }
    },
    {
      path: "/qs/orderPay_qs",
      name: "OrderPay_qs",
      component: OrderPay_qs,
      meta: {
        title: "卡面定制服务"
      }
    },
    {
      path: "/qs/mailaddress_qs",
      name: "mailaddress_qs",
      component: Mailaddress_qs,
      meta: {
        title: "卡面定制服务"
      }
    },
    {
      path: "/base/BaseQueryAction_qs",
      name: "BaseQueryAction_qs",
      component: BaseQueryAction_qs,
      meta: {
        title: "齐商银行查询入口"
      }
    },
    {
      path: "/base/BaseApplyAction_qs",
      name: "BaseApplyAction_qs",
      component: BaseApplyAction_qs,
      meta: {
        title: "齐商银行制卡入口"
      }
    },
    {
      path: "/qs/getCodeForOpenId_qs",
      name: "GetCodeForOpenId_qs",
      component: GetCodeForOpenId_qs,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/base/Invoice_qs",
      name: "Invoice_qs",
      component: Invoice_qs,
      meta: {
        title: "开具发票"
      }
    },
    {
      path: "/base/Invoicesq_qs",
      name: "Invoicesq_qs",
      component: Invoicesq_qs,
      meta: {
        title: "开具发票"
      }
    },
    //齐商银行
    {
      path: "/shzhnsh/home_shzhnsh",
      name: "Home_shzhnsh",
      component: Home_shzhnsh,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/shzhnsh/selectCardface_shzhnsh",
      name: "SelectCardface_shzhnsh",
      component: SelectCardface_shzhnsh,
      meta: {
        title: "版面定制服务",
        keepAlive: true
      }
    },
    {
      path: "/shzhnsh/uploadCardface_shzhnsh",
      name: "UploadCardface_shzhnsh",
      component: UploadCardface_shzhnsh,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/shzhnsh/editCardface_shzhnsh",
      name: "EditCardface_shzhnsh",
      component: EditCardface_shzhnsh,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/shzhnsh/orderList_shzhnsh",
      name: "OrderList_shzhnsh",
      component: OrderList_shzhnsh,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/shzhnsh/orderDetails_shzhnsh",
      name: "OrderDetails_shzhnsh",
      component: OrderDetails_shzhnsh,
      meta: {
        title: "版面定制服务"
      }
    },

    // 青岛农商银行
    {
      path: "/qingdao/SelectCardface_qingdao",
      name: "SelectCardface_qingdao",
      component: SelectCardface_qingdao,
      meta: {
        title: "青岛农商银行版面定制服务"
      }
    },
    {
      path: "/qingdao/EditCardface_qingdao",
      name: "EditCardface_qingdao",
      component: EditCardface_qingdao,
      meta: {
        title: "青岛农商银行版面定制服务"
      }
    },
    {
      path: "/qingdao/UploadCardface_qingdao",
      name: "UploadCardface_qingdao",
      component: UploadCardface_qingdao,
      meta: {
        title: "青岛农商银行版面定制服务"
      }
    },
    {
      path: "/qingdao/GetCodeForOpenId_qingdao",
      name: "GetCodeForOpenId_qingdao",
      component: GetCodeForOpenId_qingdao,
      meta: {
        title: "青岛农商银行版面定制服务"
      }
    },
    {
      path: "/qingdao/OrderPay_qingdao",
      name: "OrderPay_qingdao",
      component: OrderPay_qingdao,
      meta: {
        title: "青岛农商银行版面定制服务"
      }
    },

    //<--四川天府银行
    {
      path: "/schtnf/selectCardface_schtnf",
      name: "SelectCardface_schtnf",
      component: SelectCardface_schtnf,
      meta: {
        title: "版面定制服务",
        keepAlive: true
      }
    },
    {
      path: "/schtnf/editCardface_schtnf",
      name: "EditCardface_schtnf",
      component: EditCardface_schtnf,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/schtnf/uploadCardface_schtnf",
      name: "UploadCardface_schtnf",
      component: UploadCardface_schtnf,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/schtnf/orderList_schtnf",
      name: "OrderList_schtnf",
      component: OrderList_schtnf,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/schtnf/orderDetails_schtnf",
      name: "OrderDetails_schtnf",
      component: OrderDetails_schtnf,
      meta: {
        title: "版面定制服务"
      }
    },
    //四川天府银行-->
    //<--四川绵阳商行
    {
      path: "/schmysh/home_schmysh",
      name: "Home_schmysh",
      component: Home_schmysh,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/schmysh/selectCardface_schmysh",
      name: "SelectCardface_schmysh",
      component: SelectCardface_schmysh,
      meta: {
        title: "版面定制服务",
        keepAlive: true
      }
    },
    {
      path: "/schmysh/editCardface_schmysh",
      name: "EditCardface_schmysh",
      component: EditCardface_schmysh,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/schmysh/uploadCardface_schmysh",
      name: "UploadCardface_schmysh",
      component: UploadCardface_schmysh,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/schmysh/orderResult_schmysh",
      name: "OrderResult_schmysh",
      component: OrderResult_schmysh,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/schmysh/orderList_schmysh",
      name: "OrderList_schmysh",
      component: OrderList_schmysh,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/schmysh/orderDetails_schmysh",
      name: "OrderDetails_schmysh",
      component: OrderDetails_schmysh,
      meta: {
        title: "版面定制服务"
      }
    },
    //四川绵阳商行-->
    //<--陕西信合
    {
      path: "/shanxixinhe/home",
      name: "Home_shxxh",
      component: () => import("@/components/shanxixinhe/Home_shxxh"),
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/shanxixinhe/baseApplyAction",
      name: "BaseApplyAction_shxxh",
      component: () => import("@/components/shanxixinhe/BaseApplyAction_shxxh"),
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/shanxixinhe/baseQueryAction",
      name: "BaseQueryAction_shxxh",
      component: () => import("@/components/shanxixinhe/BaseQueryAction_shxxh"),
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/shanxixinhe/selectCardface",
      name: "SelectCardface_shxxh",
      component: () => import("@/components/shanxixinhe/SelectCardface_shxxh"),
      meta: {
        title: "版面定制服务",
        keepAlive: true
      }
    },
    {
      path: "/shanxixinhe/queryOrder",
      name: "QueryOrder_shxxh",
      component: () => import("@/components/shanxixinhe/QueryOrder_shxxh"),
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/shanxixinhe/editCardface",
      name: "EditCardface_shxxh",
      component: () => import("@/components/shanxixinhe/EditCardface_shxxh"),
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/shanxixinhe/uploadCardface",
      name: "UploadCardface_shxxh",
      component: () => import("@/components/shanxixinhe/UploadCardface_shxxh"),
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/shanxixinhe/orderPay_shxxh",
      name: "OrderPay_shxxh",
      component: () => import("@/components/shanxixinhe/OrderPay_shxxh"),
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/shanxixinhe/orderResult",
      name: "OrderResult_shxxh",
      component: () => import("@/components/shanxixinhe/OrderResult_shxxh"),
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/shanxixinhe/xinhePay",
      name: "XinhePay",
      component: () => import("@/components/shanxixinhe/XinhePay"),
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/shanxixinhe/orderConfirm",
      name: "OrderConfirm_shxxh",
      component: () => import("@/components/shanxixinhe/OrderConfirm_shxxh"),
      meta: {
        title: "版面定制服务"
      }
    },
    //陕西信合-->


    // 洪城通DIY
    {
      path: "/hongcheng/home_hongcheng",
      name: "Home_hongcheng",
      component: Home_hongcheng,
      meta: {
        title: "洪城通DIY卡"
      }
    },
    {
      path: "/hongcheng/applyCard_hongcheng",
      name: "ApplyCard_hongcheng",
      component: ApplyCard_hongcheng,
      meta: {
        title: "信息核验",
        keepAlive: true
      }
    },
    {
      path: "/hongcheng/queryOrder_hongcheng",
      name: "QueryOrder_hongcheng",
      component: QueryOrder_hongcheng,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/hongcheng/selectCardface_hongcheng",
      name: "SelectCardface_hongcheng",
      component: SelectCardface_hongcheng,
      meta: {
        title: "版面定制服务",
        keepAlive: true
      }
    },
    {
      path: "/hongcheng/editCardface_hongcheng",
      name: "EditCardface_hongcheng",
      component: EditCardface_hongcheng,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/hongcheng/uploadCardface_hongcheng",
      name: "UploadCardface_hongcheng",
      component: UploadCardface_hongcheng,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/hongcheng/orderList_hongcheng",
      name: "OrderList_hongcheng",
      component: OrderList_hongcheng,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/hongcheng/orderDetails_hongcheng",
      name: "OrderDetails_hongcheng",
      component: OrderDetails_hongcheng,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/hongcheng/orderResult_hongcheng",
      name: "OrderResult_hongcheng",
      component: OrderResult_hongcheng,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/hongcheng/orderPay_hongcheng",
      name: "OrderPay_hongcheng",
      component: OrderPay_hongcheng,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/hongcheng/getCodeForOpenId_hongcheng",
      name: "GetCodeForOpenId_hongcheng",
      component: GetCodeForOpenId_hongcheng,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/hongcheng/AlipayH5_hongcheng",
      name: "AlipayH5_hongcheng",
      component: AlipayH5_hongcheng,
      meta: {
        title: "支付宝支付"
      }
    },

    //襄阳公交定制DIY卡-->
    {
      path: "/xy/home_xy",
      name: "Home_xy",
      component: Home_xy,
      meta: {
        title: "襄阳公交定制DIY卡"
      }
    },
    {
      path: "/xy/applyCard_xy",
      name: "ApplyCard_xy",
      component: ApplyCard_xy,
      meta: {
        title: "信息核验",
        keepAlive: true
      }
    },
    {
      path: "/xy/queryOrder_xy",
      name: "QueryOrder_xy",
      component: QueryOrder_xy,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/xy/selectCardface_xy",
      name: "SelectCardface_xy",
      component: SelectCardface_xy,
      meta: {
        title: "版面定制服务",
        keepAlive: true
      }
    },
    {
      path: "/xy/editCardface_xy",
      name: "EditCardface_xy",
      component: EditCardface_xy,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/xy/uploadCardface_xy",
      name: "UploadCardface_xy",
      component: UploadCardface_xy,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/xy/orderList_xy",
      name: "OrderList_xy",
      component: OrderList_xy,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/xy/orderDetails_xy",
      name: "OrderDetails_xy",
      component: OrderDetails_xy,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/xy/orderResult_xy",
      name: "OrderResult_xy",
      component: OrderResult_xy,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/xy/orderPay_xy",
      name: "OrderPay_xy",
      component: OrderPay_xy,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/xy/getCodeForOpenId_xy",
      name: "GetCodeForOpenId_xy",
      component: GetCodeForOpenId_xy,
      meta: {
        title: "版面定制服务"
      }
    },


    // 郑州一卡通
    {
      path: "/zz/home_zz",
      name: "Home_zz",
      component: Home_zz,
      meta: {
        title: "郑州一卡通定制DIY卡"
      }
    },
    {
      path: "/zz/applyCard_zz",
      name: "ApplyCard_zz",
      component: ApplyCard_zz,
      meta: {
        title: "信息核验",
        keepAlive: true
      }
    },
    {
      path: "/zz/queryOrder_zz",
      name: "QueryOrder_zz",
      component: QueryOrder_zz,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/zz/selectCardface_zz",
      name: "SelectCardface_zz",
      component: SelectCardface_zz,
      meta: {
        title: "版面定制服务",
        keepAlive: true
      }
    },
    {
      path: "/zz/editCardface_zz",
      name: "EditCardface_zz",
      component: EditCardface_zz,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/zz/uploadCardface_zz",
      name: "UploadCardface_zz",
      component: UploadCardface_zz,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/zz/orderList_zz",
      name: "OrderList_zz",
      component: OrderList_zz,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/zz/orderDetails_zz",
      name: "OrderDetails_zz",
      component: OrderDetails_zz,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/zz/orderResult_zz",
      name: "OrderResult_zz",
      component: OrderResult_zz,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/zz/orderPay_zz",
      name: "OrderPay_zz",
      component: OrderPay_zz,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/zz/getCodeForOpenId_zz",
      name: "GetCodeForOpenId_zz",
      component: GetCodeForOpenId_zz,
      meta: {
        title: "版面定制服务"
      }
    },

    // 襄阳公交App定制DIY卡-->

        {
      path: "/xyapp/home_app_xy",
      name: "Home_app_xy",
      component: Home_app_xy,
      meta: {
        title: "襄阳公交App定制DIY卡"
      }
    },
    {
      path: "/xyapp/applyCard_app_xy",
      name: "ApplyCard_app_xy",
      component: ApplyCard_app_xy,
      meta: {
        title: "信息核验",
        keepAlive: true
      }
    },
    {
      path: "/xyapp/queryOrder_app_xy",
      name: "QueryOrder_app_xy",
      component: QueryOrder_app_xy,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/xy/selectCardface_app_xy",
      name: "SelectCardface_app_xy",
      component: SelectCardface_app_xy,
      meta: {
        title: "版面定制服务",
        keepAlive: true
      }
    },
    {
      path: "/xyapp/editCardface_app_xy",
      name: "EditCardface_app_xy",
      component: EditCardface_app_xy,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/xyapp/uploadCardface_app_xy",
      name: "UploadCardface_app_xy",
      component: UploadCardface_app_xy,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/xyapp/orderList_app_xy",
      name: "OrderList_app_xy",
      component: OrderList_app_xy,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/xyapp/orderDetails_app_xy",
      name: "OrderDetails_app_xy",
      component: OrderDetails_app_xy,
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/xyapp/orderResult_app_xy",
      name: "OrderResult_app_xy",
      component: OrderResult_app_xy,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/xyapp/orderPay_app_xy",
      name: "OrderPay_app_xy",
      component: OrderPay_app_xy,
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/xyapp/getCodeForOpenId_app_xy",
      name: "GetCodeForOpenId_app_xy",
      component: GetCodeForOpenId_app_xy,
      meta: {
        title: "版面定制服务"
      }
    },

    // 湖南银行
    {
      path: "/hunan/ApplyForCard",
      name: "ApplyForCard",
      component: ApplyForCard,
      meta: {
        title: "申请借记卡"
      }
    },
    {
      path: "/hunan/CardPreview",
      name: "CardPreview",
      component: CardPreview,
      meta: {
        title: "卡板预览"
      }
    },
    {
      path: "/hunan/Agreement",
      name: "Agreement",
      component: Agreement,
      meta: {
        title: "申请信息确认"
      }
    },
    //徽商手机银行DIY入口-->
    {
      path: "/hsapp/home_app_hs",
      name: "Home_app_hs",
      component: () => import("@/components/huishangbankApp/Home_app_hs"),
      meta: {
        title: "徽商银行徽宝成长卡"
      }
    },
    {
      path: "/hsapp/applyCard_app_hs",
      name: "ApplyCard_app_hs",
      component: () => import("@/components/huishangbankApp/ApplyCard_app_hs"),
      meta: {
        title: "信息核验",
        keepAlive: true
      }
    },
    {
      path: "/hsapp/queryOrder_app_hs",
      name: "QueryOrder_app_hs",
      component: () => import("@/components/huishangbankApp/QueryOrder_app_hs"),
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/hsapp/selectCardface_app_hs",
      name: "SelectCardface_app_hs",
      component: () => import("@/components/huishangbankApp/SelectCardface_app_hs"),
      meta: {
        title: "版面定制服务",
        keepAlive: true
      }
    },
    {
      path: "/hsapp/editCardface_app_hs",
      name: "EditCardface_app_hs",
      component: () => import("@/components/huishangbankApp/EditCardface_app_hs"),
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/hsapp/uploadCardface_app_hs",
      name: "UploadCardface_app_hs",
      component: () => import("@/components/huishangbankApp/UploadCardface_app_hs"),
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/hsapp/orderList_app_hs",
      name: "OrderList_app_hs",
      component: () => import("@/components/huishangbankApp/OrderList_app_hs"),
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/hsapp/orderDetails_app_hs",
      name: "OrderDetails_app_hs",
      component: () => import("@/components/huishangbankApp/OrderDetails_app_hs"),
      meta: {
        title: "进度查询"
      }
    },
    {
      path: "/hsapp/orderResult_app_hs",
      name: "OrderResult_app_hs",
      component: () => import("@/components/huishangbankApp/OrderResult_app_hs"),
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/hsapp/orderPay_app_hs",
      name: "OrderPay_app_hs",
      component: () => import("@/components/huishangbankApp/OrderPay_app_hs"),
      meta: {
        title: "版面定制服务"
      }
    },
    {
      path: "/hsapp/alipayH5",
      name: "AlipayH5",
      component: () => import("@/components/huishangbankApp/AlipayH5"),
      meta: {
        title: "版面定制服务"
      }
    },
    //<--徽商手机银行DIY入口
    // 迪拜及时制卡系统
    {
      path: "/Dubai/Home_Dubai",
      name: "Home_Dubai",
      component: Home_Dubai,
      meta: {
        title: "Dubai DIY Card"
      }
    },
    {
      path: "/Dubai/ApplyCard_Dubai",
      name: "ApplyCard_Dubai",
      component: ApplyCard_Dubai,
      meta: {
        title: "Dubai DIY Card"
      }
    },
    {
      path: "/Dubai/SelectCardface_Dubai",
      name: "SelectCardface_Dubai",
      component: SelectCardface_Dubai,
      meta: {
        title: "Dubai DIY Card"
      }
    },
    {
      path: "/Dubai/EditCardface_Dubai",
      name: "EditCardface_Dubai",
      component: EditCardface_Dubai,
      meta: {
        title: "Dubai DIY Card"
      }
    },
    {
      path: "/Dubai/UploadCardface_Dubai",
      name: "UploadCardface_Dubai",
      component: UploadCardface_Dubai,
      meta: {
        title: "Dubai DIY Card"
      }
    },
     {
      path: "/Dubai/OrderPay_Dubai",
      name: "OrderPay_Dubai",
      component: OrderPay_Dubai,
      meta: {
        title: "Dubai DIY Card"
      }
    },
     {
      path: "/Dubai/OrderResult_Dubai",
      name: "OrderResult_Dubai",
      component: OrderResult_Dubai,
      meta: {
        title: "Dubai DIY Card"
      }
    },
     {
      path: "/Dubai/Select_chongwu_Dubai",
      name: "Select_chongwu_Dubai",
      component: Select_chongwu_Dubai,
      meta: {
        title: "Pet DIY"
      }
    },
     {
      path: "/Dubai/Select_fengjing_Dubai",
      name: "Select_fengjing_Dubai",
      component: Select_fengjing_Dubai,
      meta: {
        title: "View DIY"
      }
    },
     {
      path: "/Dubai/Select_keji_Dubai",
      name: "Select_keji_Dubai",
      component: Select_keji_Dubai,
      meta: {
        title: "Science and technology DIY"
      }
    },
     {
      path: "/Dubai/Select_zhiwu_Dubai",
      name: "Select_zhiwu_Dubai",
      component: Select_zhiwu_Dubai,
      meta: {
        title: "Plant DIY"
      }
    },
     {
      path: "/Dubai/select_card",
      name: "select_card",
      component: select_card,
      meta: {
        title: "Dubai DIY Card"
      }
    },
     {
      path: "/Dubai/QueryOrder_Dubai",
      name: "QueryOrder_Dubai",
      component: QueryOrder_Dubai,
      meta: {
        title: "Dubai DIY Card"
      }
    },
     {
      path: "/Dubai/OrderList_Dubai",
      name: "OrderList_Dubai",
      component: OrderList_Dubai,
      meta: {
        title: "Dubai DIY Card"
      }
    },
    // 泸州银行
     {
      path: "/LuZhou/EditCardface_luzh",
      name: "EditCardface_luzh",
      component: EditCardface_luzh,
      meta: {
        title: "泸州银行DIY"
      }
    },
     {
      path: "/LuZhou/SelectCardface_luzh",
      name: "SelectCardface_luzh",
      component: SelectCardface_luzh,
      meta: {
        title: "泸州银行DIY"
      }
    },
     {
      path: "/LuZhou/test_luzhou",
      name: "test_luzhou",
      component: test_luzhou,
      meta: {
        title: "泸州银行DIY"
      }
    },
    // 泰州公交rooter
     {
      path: "/taizhou/Home_tai",
      name: "Home_tai",
      component: Home_tai,
      meta: {
        title: "泰州公交"
      }
    },
    {
      path: "/taizhou/ApplyCard_tai",
      name: "ApplyCard_tai",
      component: ApplyCard_tai,
      meta: {
        title: "泰州公交"
      }
    },
    {
      path: "/taizhou/SelectCardface_tai",
      name: "SelectCardface_tai",
      component: SelectCardface_tai,
      meta: {
        title: "泰州公交"
      }
    },
    {
      path: "/taizhou/EditCardface_tai",
      name: "EditCardface_tai",
      component: EditCardface_tai,
      meta: {
        title: "泰州公交"
      }
    },
    {
      path: "/taizhou/UploadCardface_tai",
      name: "UploadCardface_tai",
      component: UploadCardface_tai,
      meta: {
        title: "泰州公交"
      }
    },
    {
      path: "/taizhou/OrderPay_tai",
      name: "OrderPay_tai",
      component: OrderPay_tai,
      meta: {
        title: "泰州公交"
      }
    },
    {
      path: "/taizhou/GetCodeForOpenId_tai",
      name: "GetCodeForOpenId_tai",
      component: GetCodeForOpenId_tai,
      meta: {
        title: "泰州公交"
      }
    },
    {
      path: "/taizhou/OrderResult_tai",
      name: "OrderResult_tai",
      component: OrderResult_tai,
      meta: {
        title: "泰州公交"
      }
    },
    {
      path: "/taizhou/OrderDetails_tai",
      name: "OrderDetails_tai",
      component: OrderDetails_tai,
      meta: {
        title: "泰州公交"
      }
    },
    {
      path: "/taizhou/OrderList_tai",
      name: "OrderList_tai",
      component: OrderList_tai,
      meta: {
        title: "泰州公交"
      }
    },
    {
      path: "/taizhou/QueryOrder_tai",
      name: "QueryOrder_tai",
      component: QueryOrder_tai,
      meta: {
        title: "泰州公交"
      }
    },
   
    // UI----------------------------------------------------------------------------------------------------------------------------------
      {
      path: "/demo/HomePage",
      name: "HomePage",
      component: HomePage,
      meta: {
        title: "主界面"
      }
    },
      {
      path: "/demo/InformationFilling",
      name: "InformationFilling",
      component: InformationFilling,
      meta: {
        title: "请填写您的信息"
      }
    },
      {
      path: "/demo/SelectBusinessProcess",
      name: "SelectBusinessProcess",
      component: SelectBusinessProcess,
      meta: {
        title: "业务版面"
      }
    },
      {
      path: "/demo/AISelectCardface",
      name: "AISelectCardface",
      component: AISelectCardface,
      meta: {
        title: "AI卡面"
      }
    },
      {
      path: "/demo/AItext_to_image",
      name: "AItext_to_image",
      component: AItext_to_image,
      meta: {
        title: "文生图"
      }
    },
      {
      path: "/demo/AIimage_text_to_image",
      name: "AIimage_text_to_image",
      component: AIimage_text_to_image,
      meta: {
        title: "图文生图"
      }
    },
      {
      path: "/demo/AIimage_to_image",
      name: "AIimage_to_image",
      component: AIimage_to_image,
      meta: {
        title: "图生图"
      }
    },
      {
      path: "/demo/AICollection",
      name: "AICollection",
      component: AICollection,
      meta: {
        title: "收藏夹"
      }
    },
      {
      path: "/demo/AIEditCardface",
      name: "AIEditCardface",
      component: AIEditCardface,
      meta: {
        title: "图片编辑"
      }
    },
      {
      path: "/demo/AIUploadCardface",
      name: "AIUploadCardface",
      component: AIUploadCardface,
      meta: {
        title: "卡面确认"
      }
    },
      {
      path: "/demo/AIThreeD",
      name: "AIThreeD",
      component: AIThreeD,
      meta: {
        title: "3D展示"
      }
    },
      {
      path: "/demo/OrderPay_demo",
      name: "OrderPay_demo",
      component: OrderPay_demo,
      meta: {
        title: "OrderPay_demo"
      }
    },
      {
      path: "/demo/GetCodeForOpenId_demo",
      name: "GetCodeForOpenId_demo",
      component: GetCodeForOpenId_demo,
      meta: {
        title: "GetCodeForOpenId_demo"
      }
    },
        {
      path: "/demo/OrderResult_demo",
      name: "OrderResult_demo",
      component: OrderResult_demo,
      meta: {
        title: "OrderResult_demo"
      }
    },
        {
      path: "/demo/QueryOrder_demo",
      name: "QueryOrder_demo",
      component: QueryOrder_demo,
      meta: {
        title: "QueryOrder_demo"
      }
    },
        {
      path: "/demo/OrderList_demo",
      name: "OrderList_demo",
      component: OrderList_demo,
      meta: {
        title: "OrderList_demo"
      }
    },
        {
      path: "/demo/OrderDetails_demo",
      name: "OrderDetails_demo",
      component: OrderDetails_demo,
      meta: {
        title: "OrderDetails_demo"
      }
    },
        {
      path: "/demo/SelectCardface_demo",
      name: "SelectCardface_demo",
      component: SelectCardface_demo,
      meta: {
        title: "SelectCardface_demo"
      }
    },
        {
      path: "/demo/EditCardface_demo",
      name: "EditCardface_demo",
      component: EditCardface_demo,
      meta: {
        title: "EditCardface_demo"
      }
    },
        {
      path: "/demo/UploadCardface_demo",
      name: "UploadCardface_demo",
      component: UploadCardface_demo,
      meta: {
        title: "UploadCardface_demo"
      }
    },   
        {
      path: "/demo/AItest",
      name: "AItest",
      component: AItest,
      meta: {
        title: "AItest"
      }
    },   
        {
      path: "/demo/ThreeD",
      name: "ThreeD",
      component: ThreeD,
      meta: {
        title: "ThreeD"
      }
    }, 
    // 宁波公交
        {
      path: "/ningbo/test_ningbo",
      name: "test_ningbo",
      component: test_ningbo,
      meta: {
        title: "宁波公交"
      }
    },   
        {
      path: "/ningbo/home_ningbo",
      name: "home_ningbo",
      component: home_ningbo,
      meta: {
        title: "首页"
      }
    },   
     
    //抠图 
        {
      path: "/ningbo/selectTopic_ningbo",
      name: "selectTopic_ningbo",
      component: selectTopic_ningbo,
      meta: {
        title: "一键抠图"
      }
    },   
       {
      path: "/ningbo/matting_ningbo",
      name: "matting_ningbo",
      component: matting_ningbo,
      meta: {
        title: "一键抠图",
        // keepAlive: true, // 需要缓存
         },
    },  
       {
      path: "/ningbo/matting_ningbocute",
      name: "matting_ningbocute",
      component: matting_ningbocute,
      meta: {
        title: "一键抠图",
        keepAlive: true, // 需要缓存
         clearCacheOnBack: true // 返回A时需要清除缓存
         },
    },  
       {
      path: "/ningbo/matting_ningbogirl",
      name: "matting_ningbogirl",
      component: matting_ningbogirl,
      meta: {
        title: "一键抠图",
        keepAlive: true, // 需要缓存
         clearCacheOnBack: true // 返回A时需要清除缓存
         },
    },  
       {
      path: "/ningbo/matting_ningboboy",
      name: "matting_ningboboy",
      component: matting_ningboboy,
      meta: {
        title: "一键抠图",
        keepAlive: true, // 需要缓存
         clearCacheOnBack: true // 返回A时需要清除缓存
         },
    },  
       {
      path: "/ningbo/matting_ningbolovers",
      name: "matting_ningbolovers",
      component: matting_ningbolovers,
      meta: {
        title: "一键抠图",
        keepAlive: true, // 需要缓存
         clearCacheOnBack: true // 返回A时需要清除缓存
         },
    },  
       {
      path: "/ningbo/selectReverseSide_matting_ningbo",
      name: "selectReverseSide_matting_ningbo",
      component: selectReverseSide_matting_ningbo,
      meta: {
        title: "选择背景"
      }
    },  
       {
      path: "/ningbo/uploadCardface_matting_ningbo",
      name: "uploadCardface_matting_ningbo",
      component: uploadCardface_matting_ningbo,
      meta: {
        title: "信息确认"
      }
    },  
       {
      path: "/ningbo/informationFilling_matting_ningbo",
      name: "informationFilling_matting_ningbo",
      component: informationFilling_matting_ningbo,
      meta: {
        title: "信息填写"
      }
    },  
       {
      path: "/ningbo/orderPay_matting_ningbo",
      name: "orderPay_matting_ningbo",
      component: orderPay_matting_ningbo,
      meta: {
        title: "订单支付"
      }
    },  
       {
      path: "/ningbo/getCodeForOpenId_matting_ningbo",
      name: "getCodeForOpenId_matting_ningbo",
      component: getCodeForOpenId_matting_ningbo,
      meta: {
        title: "宁波公交"
      }
    },  

    // 自选卡面
        {
      path: "/ningbo/selectCardface_customs_ningbo",
      name: "selectCardface_customs_ningbo",
      component: selectCardface_customs_ningbo,
      meta: {
        title: "照片定制"
      }
    },   
        {
      path: "/ningbo/orderResult_matting_ningbo",
      name: "orderResult_matting_ningbo",
      component: orderResult_matting_ningbo,
      meta: {
        title: "照片定制"
      }
    },   
        {
      path: "/ningbo/editCardface_customs_ningbo",
      name: "editCardface_customs_ningbo",
      component: editCardface_customs_ningbo,
      meta: {
        title: "照片定制"
      }
    },   
        {
      path: "/ningbo/selectReverseSide_customs_ningbo",
      name: "selectReverseSide_customs_ningbo",
      component: selectReverseSide_customs_ningbo,
      meta: {
        title: "照片定制"
      }
    },   
        {
      path: "/ningbo/uploadCardface_customs_ningbo",
      name: "uploadCardface_customs_ningbo",
      component: uploadCardface_customs_ningbo,
      meta: {
        title: "照片定制"
      }
    },   
       
        {
      path: "/ningbo/informationFilling_customs_ningbo",
      name: "informationFilling_customs_ningbo",
      component: informationFilling_customs_ningbo,
      meta: {
        title: "信息填写"
      }
    },   
        {
      path: "/ningbo/orderPay_customs_ningbo",
      name: "orderPay_customs_ningbo",
      component: orderPay_customs_ningbo,
      meta: {
        title: "订单支付"
      }
    },   
        {
      path: "/ningbo/getCodeForOpenId_customs_ningbo",
      name: "getCodeForOpenId_customs_ningbo",
      component: getCodeForOpenId_customs_ningbo,
      meta: {
        title: "订单支付"
      }
    },   
        {
      path: "/ningbo/orderResult_customs_ningbo",
      name: "orderResult_customs_ningbo",
      component: orderResult_customs_ningbo,
      meta: {
        title: "支付结果"
      }
    },   
    // 查询
        {
      path: "/ningbo/orderDetails_ningbo",
      name: "orderDetails_ningbo",
      component: orderDetails_ningbo,
      meta: {
        title: "支付结果"
      }
    },   
        {
      path: "/ningbo/orderList_ningbo",
      name: "orderList_ningbo",
      component: orderList_ningbo,
      meta: {
        title: "支付结果"
      }
    },   
        {
      path: "/ningbo/queryOrder_ningbo",
      name: "queryOrder_ningbo",
      component: queryOrder_ningbo,
      meta: {
        title: "支付结果"
      }
    },   
    // 支付
        {
      path: "/ningbo/orderPay_ningbo",
      name: "orderPay_ningbo",
      component: orderPay_ningbo,
      meta: {
        title: "订单支付"
      }
    },   
        {
      path: "/ningbo/getCodeForOpenId_ningbo",
      name: "getCodeForOpenId_ningbo",
      component: getCodeForOpenId_ningbo,
      meta: {
        title: "订单支付"
      }
    },   
        {
      path: "/ningbo/orderResult_ningbo",
      name: "orderResult_ningbo",
      component: orderResult_ningbo,
      meta: {
        title: "订单支付"
      }
    },   
    //  固定卡面
    //       {
    //   path: "/ningbo/fixedCardFace_ningbo",
    //   name: "fixedCardFace_ningbo",
    //   component: fixedCardFace_ningbo,
    //   meta: {
    //     title: "固定卡面"
    //   }
    // },   
    // AI
          {
      path: "/ningbo/informationFilling_ai_ningbo",
      name: "informationFilling_ai_ningbo",
      component: informationFilling_ai_ningbo,
      meta: {
        title: "AIGC"
      }
    },   
          {
      path: "/ningbo/AISelectCardface_ningbo",
      name: "AISelectCardface_ningbo",
      component: AISelectCardface_ningbo,
      meta: {
        title: "AIGC"
      }
    },   
          {
      path: "/ningbo/AICollection_ningbo",
      name: "AICollection_ningbo",
      component: AICollection_ningbo,
      meta: {
        title: "AIGC"
      }
    },   
          {
      path: "/ningbo/AIimage_text_to_image_ningbo",
      name: "AIimage_text_to_image_ningbo",
      component: AIimage_text_to_image_ningbo,
      meta: {
        title: "AIGC"
      }
    },   
          {
      path: "/ningbo/AIimage_to_image_ningbo",
      name: "AIimage_to_image_ningbo",
      component: AIimage_to_image_ningbo,
      meta: {
        title: "AIGC"
      }
    },   
          {
      path: "/ningbo/AItext_to_image_ningbo",
      name: "AItext_to_image_ningbo",
      component: AItext_to_image_ningbo,
      meta: {
        title: "AIGC"
      }
    },   
          {
      path: "/ningbo/AIEditCardface_ningbo",
      name: "AIEditCardface_ningbo",
      component: AIEditCardface_ningbo,
      meta: {
        title: "AIGC"
      }
    },   
          {
      path: "/ningbo/SelectReverseSide_ai_ningbo",
      name: "SelectReverseSide_ai_ningbo",
      component: SelectReverseSide_ai_ningbo,
      meta: {
        title: "AIGC"
      }
    },   
          {
      path: "/ningbo/uploadCardface_ai_ningbo",
      name: "uploadCardface_ai_ningbo",
      component: uploadCardface_ai_ningbo,
      meta: {
        title: "AIGC"
      }
    },   
          {
      path: "/ningbo/invoicesq_ningbo",
      name: "invoicesq_ningbo",
      component: invoicesq_ningbo,
      meta: {
        title: "开具发票"
      }
    },   
          {
      path: "/ningbo/orderPay_app_ningbo",
      name: "orderPay_app_ningbo",
      component: orderPay_app_ningbo,
      meta: {
        title: "订单支付"
      }
    },   
          {
      path: "/ningbo/getCodeForOpenId_app_ningbo",
      name: "getCodeForOpenId_app_ningbo",
      component: getCodeForOpenId_app_ningbo,
      meta: {
        title: "订单支付"
      }
    },   
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js